// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1Ifwe","bigColWidth":"Table_bigColWidth__2uZ_B","biggerColWidth":"Table_biggerColWidth__3LBX7","row":"Table_row__2a0cD","col":"Table_col__1ous1"};